import api from '../libs/axios';

export const getUserInfo = async (params, signal) => {
  const response = await api.get('/user', { params, signal });
  return response.data;
};
